import request from '../utils/request'

// 频道列表
export function channelAll(params) {
    return request({
        url: '/channel/all',
        method: 'get',
        params
    })
}

// 资讯列表
export function contentList (params) {
    return request({
        url: '/content/queryContentMini', // '/content/list',
        method: 'post',
        header: {
            version: '2.7.2'
        },
        params
    })
}

